import React from 'react';
import {ServiceBase} from '../ServiceBase';
import {
  IExternalLinksService,
  IOpenGameLimitsOptions,
  IOpenOmgOptions,
  IOpenPendingLoginOptions,
  OpenRichPageOptions
} from './external-links.service.interface';
import {IOpenMyAccountOptions} from "./handlers/my-account/my-account.external-link-handler.interface";
import {IOpenRegistrationOptions} from "./handlers/registration/registration.external-link-handler.interface";
import {IExternalLinksProxy} from "../../../common/interfaces/external-links-proxy.interface";
import {OpenCashierOptions} from "../../../common/interfaces/cashier.service.interface";
import {
  PendingActionResultEnum
} from "./handlers/pending-action/pending-action.external-link-handler.interface";
import {
  IOpenRealGamePlayPendingActionOptions
} from "./handlers/pending-action/real-game-play/real-game-play-pending-action.external-link-handler.interface";
import {IExternalLinksHandlersFactory} from "./handlers-factory/external-links-handlers-factory.interface";
import {MarketingParams} from "../../../common/interfaces/marketing-params.interface";
import Device from "../../../sdk/src/utils/device/device";


export class ExternalLinksService extends ServiceBase implements IExternalLinksService, IExternalLinksProxy {


  private get _handlers(): IExternalLinksHandlersFactory {
    return this.services.regulation.current.externalLinks;
  }


  async openMyAccount(options?: IOpenMyAccountOptions, marketingParams?: MarketingParams): Promise<void> {
    await this._handlers.myAccount.openMyAccount(options);
  }

  async openCashier(options?: OpenCashierOptions): Promise<void> {
    await this._handlers.cashier.openCashier(options);
  }

  async openMembership(options?: IOpenRegistrationOptions): Promise<void> {
    this.services.dialog.closeAllDialogs();
    await this._handlers.registration.openRegistration(options);
  }

  openOMG(options: IOpenOmgOptions): Promise<void> {
    return this._handlers.omg.openOmg(options);
  }

  openForgotPassword(): Promise<void> {
    return this._handlers.forgotPassword.openForgotPassword();
  }

  openForgotUserName(): Promise<void> {
    return this._handlers.forgotUserName.openForgotUserName();
  }

  openPendingLogin(options: IOpenPendingLoginOptions): Promise<void> {
    return this._handlers.pendingLogin.openPendingLogin(options);
  }

  openRealGamePlayPendingAction(options?: IOpenRealGamePlayPendingActionOptions): Promise<PendingActionResultEnum> {
    return this._handlers.realGamePlayPendingAction.openPendingAction(options);
  }

  openUploadDocumentFromMyAccount(): Promise<void> {
    return this._handlers.myAccountUploadDocuments.openUploadDocumentsFromMyAccount();
  }

  openGameLimits(options:IOpenGameLimitsOptions): Promise<void>{
    return this._handlers.gameLimits.openGameLimits(options);
  }

  openContactUs(): Promise<void> {
    return this._handlers.contactUs.openContactUs();
  }

  openRichPage(options: OpenRichPageOptions): Promise<void> {
    return this._handlers.rich.openRichPage(options);
  }

  renderRichPageContent(): Promise<React.ReactElement> {
    return this._handlers.rich.renderRichPageContent();
  }

  openHelpPage(): Promise<void> {
    return this._handlers.help.openHelpPage();
  }

  async openDepositPendingAction(): Promise<PendingActionResultEnum> {
    return this._handlers.depositPendingAction.openPendingAction();
  }
  async openTransactionHistoryPendingAction(): Promise<PendingActionResultEnum> {
    return this._handlers.transactionHistoryPendingAction.openPendingAction();
  }

  openBankId(url: string): void {
    if(Device.hybrid.inCasino) {
      this.services.hybrid.openExternalLink(url);
    } else {
      /*
          BankId url is an url with custom schema something like 'bankid:///?autostarttoken
          This will basically rely on the browser that will ask the operating system to handle bankid schema which in the end will open an application.
          On some browsers this works with window.location.assign and on others with window.open. This is the reason we do those two subsequent calls.
          Only one of them will be succesfull. And even if both will succeed the BankID application is a single instance application so only one instance will be opened.
       */
      window.location.assign(url);
      const tab = window.open(url);
      tab && tab.close();
    }
  }

  async openDownloadApp(): Promise<void> {
    await this.services.linksNavigation.openUrl({
      url: this.services.sdk.getDownloadAppLink(),
      openMode: 'redirect'
    });

    /*
    await this.openLink({
        sourceLink: this.services.sdk.getDownloadAppLink(),
        view: 'redirect',
        resolveByCallback: false
    });

     */
  }

  async openOldChat(): Promise<void> {
    await this.services.linksNavigation.navigateLink({
      linkId: "chatLink"
    });
  }
}